









































































import { defineComponent, computed, toRefs, reactive } from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';

import userValidator from '@/renderer/components/user/compositions/userValidator';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import useLDAPLogin from '@/renderer/components/login/compositions/useLDAPLogin';

import SelectInput from './SelectInput.vue';

export default defineComponent({
  components: { ChevronLeftIcon, SelectInput },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    initInfo: {
      type: Object,
      default: {
        step: 1,
        loginConfigList: [],
        ldapType: '',
        loginFlag: '',
      },
    },
  },
  setup(props, context) {
    const vm = context.root;
    const store = vm.$store;
    const { isCustomizedDomain } = CONSTANT_URL;

    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const formData = reactive({
      loginAccount: '',
      loginPassword: '',
    });
    const { rules } = userValidator(formData);

    const confirmDisabled = computed(() => !formData.loginAccount || !formData.loginPassword);

    const {
      corpId,
      corpIdList,
      loading,
      step,
      loginConfigList,
      ldapType,
      loginFlag,
      methods: ldapMethods,
    } = useLDAPLogin();

    const methods = {
      initData() {
        const { initInfo } = toRefs(props);
        if (initInfo.value.step !== 1) {
          step.value = initInfo.value.step.value;
          loginConfigList.value = initInfo.value.loginConfigList.value;
          ldapType.value = initInfo.value.ldapType.value;
          loginFlag.value = initInfo.value.loginFlag.value;
        }
      },
      cancel() {
        const hasOnlyOneCorpId = isCustomizedDomain || store.getters.corpList.length === 1;
        if (hasOnlyOneCorpId || step.value === 1) {
          // 有唯一的企业id或第一步时点后退 都回到登录页
          context.emit('cancel');
          innerShow.value = false;
        } else {
          step.value = 1;
        }
      },
      login() {
        ldapMethods.onSubmit(formData.loginAccount, formData.loginPassword);
      },
    };

    methods.initData();
    ldapMethods.initList();

    return {
      innerShow,
      step,
      corpId,
      corpIdList,
      loginConfigList,
      ldapType,
      loginFlag,
      formData,
      rules,
      confirmDisabled,
      loading,
      ...methods,
      ...ldapMethods,
    };
  },
});
